<template>
  <div id="app" :key="appKey">
    <header v-if="isAuthenticated" class="header">
      <appHeader />
    </header>

    <div class="content">
      <router-view />
    </div>

    <footer class="footer">
      <appFooter />
    </footer>

    <go-top :boundary="250" :max-width="320" weight="bold" />

    <appLoaderOverlay />
  </div>
</template>

<script>
import GoTop from "@inotom/vue-go-top";

import appHeader from "@/components/Header";
import appFooter from "@/components/Footer";

import BuildingORM from "@/store/orm-axios/models/Building";
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";
import MeetingGuestORM from "@/store/orm-axios/models/MeetingGuest";
import MeetingORM from "@/store/orm-axios/models/Meeting";

export default {
  components: {
    appHeader,
    appFooter,
    GoTop,
  },
  data() {
    return {
      selectedBuilding: null,
      showModal: false,
      appKey: 0,
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters["auth/isAuthenticated"];
    },
    UserBuildings() {
      return BuildingORM.all();
    },
    UserBuildingOwners() {
      return BuildingOwnerORM.all();
    },
    meetingGuest() {
      if (this.meeting_guest_id) {
        return MeetingGuestORM.find(this.meeting_guest_id);
      } else {
        return null;
      }
    },
  },
  async created() {
    if (this.$store.getters["auth/isAuthenticated"]) {
      if (!this.roles.includes("ROLE_MEETING_GUEST")) {
        if (this.$_.isArray(this.UserBuildings) && this.UserBuildings.length < 1) {
          // ???: gets too much data..
          await this.getUserBuildings();
          // ???: building owners come with building in prevoious api call
          await this.getBuildingOwnersFromBuilding();
          if (this.selectedBuilding == null) {
            if (this.UserBuildings.length > 1) {
              this.showModal = true;
            } else {
              this.setSelected(this.UserBuildings[0]);
            }
          }
        }
      } else {
        // !!!: ???: ?????????????????????????????????
        await this.GetMeetingGuests();
        await this.GetMeetingById(this.meetingGuest.meeting_id);
        await this.getBuildingOwnersFromBuilding();
      }
    }
    await this.$store.dispatch("getCountries");
  },
  async updated() {
    // TODO: check this code, seems to be not wrong
    if (this.roles && this.roles.includes("ROLE_BUILDING_OWNER")) {
      if (this.selectedBuilding == null) {
        if (localStorage.building_id) {
          this.selectedBuilding = BuildingORM.find(this.building_id);
          if (this.$route.name == "login") {
            this.$router.push({ name: "meetings" });
            // this.appKey++;
          }
        } else {
          // this.appKey++;
          // if (this.UserBuildings.length > 1) {
          //   this.showModal = true;
          // } else {
          //   this.selectedBuilding = this.UserBuildings[0];
          // }
        }
      } else {
        if (this.$route.name == "login") {
          this.$router.push({ name: "meetings" });
        }
      }
    } else if (this.roles && this.roles.includes("ROLE_MEETING_GUEST")) {
      // await this.GetMeetingGuests();
      // await this.GetMeetingById(this.meetingGuest.meeting_id);
      // await this.getBuildingOwnersFromBuilding();
      if (this.$route.name == "login") {
        this.$router.push({ name: "meetings" });
      }
    }
  },
  methods: {
    async GetMeetingById(id) {
      MeetingORM.api()
        .GET(id)
        .then(res => {
          // console.log("MeetingORM.api/().GET res", res);
          // set building_id
          var meeting = MeetingORM.find(this.meetingGuest.meeting_id);
          localStorage.setItem("building_id", meeting.building_id);
        })
        .catch(err => {
          console.error("MeetingORM.api().GET error: ", err);
        });
    },
    async GetMeetingGuests() {
      await MeetingGuestORM.api()
        .FETCH()
        .then(res => {
          console.log("MeetingGuestORM.FETCH() res", res);
        })
        .catch(err => {
          console.error("MeetingGuestORM.FETCH() err", err);
        });
      console.log("All Guests", MeetingGuestORM.all());
      var meetingGuest = MeetingGuestORM.query()
        .where(mg => {
          return mg.username == this.username;
        })
        .first();

      console.log("meetingGuest", meetingGuest);

      if (meetingGuest) {
        // set meeting guest id
        localStorage.setItem("meeting_guest_id", meetingGuest.id);
      }
    },
    // ???: ?????????????????????????????????
    async getUserBuildings() {
      await BuildingORM.api()
        .FETCH()
        .then(res => {
          return res;
        })
        .catch(err => {
          console.error(err);
        });
    },
    async getBuildingOwnersFromBuilding() {
      // ???: ????????????????????????????
      await BuildingOwnerORM.api()
        .FETCH(localStorage.building_id)
        .then(res => {
          return res;
        })
        .catch(err => {
          console.warn("error", err);
          return err;
        });
    },
    setSelected(selectedBuilding) {
      this.selectedBuilding = selectedBuilding;
      localStorage.setItem("selectedBuilding", JSON.stringify(selectedBuilding));
      localStorage.setItem("building_id", selectedBuilding["id"]);
      var bow = BuildingOwnerORM.query()
        .where("user_id", localStorage.userId)
        .where("building_id", localStorage.building_id)
        .withAllRecursive(1)
        .first();
      // localStorage.building_owner_id = bow.id;
      // console.log("success");
      this.isLoadingLogin = false;
      // console.log(new Date(), "this.$route.name == 'login'", this.$route.name == "login");
      // console.log(new Date(), "this.$route.name ", this.$route.name);
      if (this.$route.name == "login") {
        this.$router.push({ name: "meetings" });
      }
      this.showModal = false;
      this.appKey++;
    },
  },
};
</script>

<style lang="scss">
// import Bootstrap and BootstrapVue scss files
@import "~bootstrap/scss/bootstrap";
@import "~bootstrap-vue/src/index.scss";
@import "~bootstrap-icons/font/bootstrap-icons.css";

// import other packages style files
@import "~vue-select/src/scss/vue-select.scss";
@import "~vue-multiselect/dist/vue-multiselect.min.css";
@import "~vue2-datepicker/index.css";
@import "~pretty-checkbox/src/pretty-checkbox.scss";

// import main scss file last
@import "@/assets/scss/main";
</style>
